import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Form from 'core/forms/Form';
import Field from 'core/forms/Field';
import RMGrid from 'core/grid';

import UserDetailsFormInputs from 'common/components/UserDetails/UserDetailsFormInputs';

import { withRouter } from 'react-router';

import Button from 'common/components/Button';

import { TermsOfUse } from 'containers/Help';

import { gridColumns, gridConfig } from './registerGridOptions';

import PaypalCheckout from 'common/components/PaypalCheckout';

import _pick from 'lodash/pick';

import { globalConfig, localeStrings as strings } from 'applicationConfig';

@inject('tradingVenuesStore', 'userStore', 'settingsStore')
@observer
class RegisterForm extends Component {
  constructor(props) {
    super(props);

    this.openTermsPopup = this.openTermsPopup.bind(this);
  }

  componentDidMount() {
    this.props.tradingVenuesStore.LoadTadingVenues().then(() => {
      if (globalConfig.NO_PAYPAL_MODE) {
        this.props.tradingVenuesStore.SetReadOnlyDelayedMode();
      }
    });
  }

  componentWillUnmount() {
    this.props.userStore.clearSubscribeInfo();
  }

  onSubmit = (values) => {
    const { userStore, tradingVenuesStore } = this.props;
    return userStore
      .register(
        _pick(values, [ 'email', 'firstName', 'lastName', 'question', 'answer', 'country', 'company', 'phoneNumber' ]),
        tradingVenuesStore.registerVenues
      )
      .then((res) => {
        this.props.formStore.resetCaptcha();
      });
  };

  onPaymentSuccess = (free) => {
    this.props.settingsStore.showSimpleAlert(
      free ? strings.register.registrationSuccess : strings.register.successPaymentMessage
    );
    this.props.history.push('/login');
  };

  openTermsPopup(e) {
    e.preventDefault();

    this.props.settingsStore.setAlertData({
      ChildElement: TermsOfUse,
      message: strings.register.termsOfUse,
      cancelLabel: strings.generic.cancel,
      confirmLabel: strings.register.confirm,
      onConfirm: () => {
        this.props.formStore.onChangeFieldValue('termsConfirmed', true);
      }
    });
    return false;
  }

  componentWillUpdate() {
    const { subscribeUserId, subscribeCost } = this.props.userStore;
    if (subscribeUserId && subscribeCost === 0) {
      this.onPaymentSuccess(true);
    }
  }

  render() {
    const { venues, realtimeOrderCost, realtimeTradeCost, registerVenues } = this.props.tradingVenuesStore;
    const { subscribeUserId, subscribeCost } = this.props.userStore;
    const isUnderSubscribeProccess = !globalConfig.NO_PAYPAL_MODE && (subscribeUserId !== null && subscribeUserId > 0);

    const selectionCaption = globalConfig.NO_PAYPAL_MODE
      ? strings.register.selectionCaptionAlt
      : strings.register.selectionCaption.replace('$1', realtimeTradeCost).replace('$0', realtimeOrderCost);

    return (
      <Form onSubmit={this.onSubmit} formStore={this.props.formStore}>
        <div className="register-form">
          <p>
            <span>{strings.register.terms} </span>
            <a href="#terms" onClick={this.openTermsPopup}>
              {strings.register.termsLinkText}
            </a>.
          </p>
          <div className="terms-field-group">
            <p>{strings.register.termsConfirm}</p>
            <div className="field-group-value terms-checkbox-wrap">
              <Field component="input" type="checkbox" name="termsConfirmed" disabled={isUnderSubscribeProccess} />.
            </div>
          </div>
          <div>
            <p>{selectionCaption}</p>
          </div>
          <div className="trading-venues">
            <RMGrid columns={gridColumns} rows={venues} gridConfig={gridConfig} />
            {isUnderSubscribeProccess && <div className="disabling-ovelay" />}
          </div>
          {isUnderSubscribeProccess ? (
            <div className="subscribe-wrap">
              <div className="subscribe-cost-wrap">
                <span>{strings.register.costInfo}</span>
                <span className="cost-currency">$</span>
                <span className="cost-value">{subscribeCost}</span>
              </div>
              <div className="paypal-checkout-wrap">
                <PaypalCheckout
                  createParams={{ userId: subscribeUserId }}
                  onExecutePaymentSuccess={this.onPaymentSuccess}
                />
              </div>
            </div>
          ) : (
            <div className="register-fields-wrap user-details-fields">
              <p className="register-form-caption">{strings.register.formCaption}</p>
              <UserDetailsFormInputs formStore={this.props.formStore} />

              <div className="actions">
                <Button
                  className="btn btn-primary"
                  type="submit"
                  disabled={!(registerVenues.length && this.props.formStore.isValid)} //TODO: get isFormSubmitted back
                >
                  <span className="button-caption">{strings.register.submitButtonCaption}</span>
                </Button>
              </div>
            </div>
          )}
        </div>
      </Form>
    );
  }
}

export default withRouter(RegisterForm);



// WEBPACK FOOTER //
// ./src/containers/Register/RegisterForm.jsx